import React from 'react';
import { formatPrice } from '../../utils/formatters';
import { RARITY_MAP } from '../../utils/constants';

export default function CardGridItem({ card, onClick }) {
  const name = card.display_name || card.card_name || 'Unknown';
  const set = card.display_extension || card.extension;
  const rarity = card.display_rarity || card.rarity;
  const language = card.language;
  const isLinked = !!card.tcg_card_id;

  // Use listing image, fall back to TCG ref image
  const imageUrl = card.image_url
    ? card.image_url.replace(/s-l\d+/, 's-l400')
    : card.tcg_card?.image_small || null;

  return (
    <div
      className={`card-grid-item ${isLinked ? 'card-grid-item--linked' : ''}`}
      onClick={() => onClick(card)}
    >
      <div className="card-grid-image-container">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={name}
            className="card-grid-image"
            loading="lazy"
          />
        ) : (
          <div className="card-grid-placeholder">?</div>
        )}
        {/* Price overlay */}
        <div className="card-grid-price-badge">
          {formatPrice(card.price, card.currency)}
        </div>
        {/* Source badge */}
        <div className={`card-grid-source-badge source-${card.source}`}>
          {card.source}
        </div>
      </div>

      <div className="card-grid-info">
        <div className="card-grid-name" title={name}>
          {name}
        </div>
        {set && (
          <div className="card-grid-set" title={set}>
            {set}
          </div>
        )}
        <div className="card-grid-badges">
          {rarity && (
            <span
              className={`rarity-badge rarity-${rarity.toLowerCase()}`}
              title={RARITY_MAP[rarity] || rarity}
            >
              {rarity}
            </span>
          )}
          {language && (
            <span className="language-badge">{language}</span>
          )}
        </div>
      </div>
    </div>
  );
}
